/**
 * The scenes (`# ` headings) of one dream segment, with their anchor letters and a copy button per
 * scene. Extracted from `SegmentUI.tsx` so the long-text tab can render it without a circular import
 * (the tab components live in this folder, and `SegmentUI.tsx` imports them).
 *
 * Used in two places, deliberately:
 *  - the segment header (read-only preview, `hideIfNoScenes = true`);
 *  - the long-text tab of the segment editor (`hideIfNoScenes = false`).
 */
import {CopyText} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Button, Column, Row, Text} from "react-vcomponents";
import {ES} from "web-vcore";
import {GetEntity} from "../../../../Server/DB/entities.js";
import {JournalEntry, JournalSegment} from "../../../../Server/DB/journalEntries/@JournalEntry.js";
import {GetScenesForJournalEntryAndSegment} from "../../../../Server/DB/journalEntries/$journalEntry.js";
import {store} from "../../../../Store/index.js";
import {ACTSetCopiedData, CopiedData, JournalPathToString} from "../../../../Store/main/general/CopiedData.js";
import {GetMapObjectsPerDreamScene} from "../../SceneList/ScenePreview.js";

export const SegmentScenesUI = observer_mgl((props: {entry: JournalEntry, segment: JournalSegment, hideIfNoScenes: boolean})=>{
	const {entry, segment, hideIfNoScenes} = props;
	const selectedMapID = store.main.maps.selectedMapID;
	const scenes = GetScenesForJournalEntryAndSegment(entry, segment);
	if (hideIfNoScenes && scenes.length == 0) return null;
	const sceneAnchorEntities = scenes.map(scene=>GetEntity(scene.sceneAnchorId));
	const mapObjectsPerScene = scenes.length ? GetMapObjectsPerDreamScene(selectedMapID) : null;

	return (
		<Column plr={5}>
			<Row>Scenes:</Row>
			{scenes.map(scene=>{
				const {sceneTitle, sceneIndex} = scene;
				let str = `${sceneIndex + 1}: ${sceneTitle}`;
				if (sceneAnchorEntities[sceneIndex]) {
					const entityName = sceneAnchorEntities[sceneIndex]?.name;
					if (entityName) str += ` [${entityName[0]?.toUpperCase() ?? ""}]`;
				}
				return (
					<Row key={sceneIndex} style={{gap: 5}}>
						<Text style={ES(
							mapObjectsPerScene && mapObjectsPerScene.has(JournalPathToString({entryId: entry.id, segmentId: segment.id!, sceneIndex})) && {color: "rgba(0,255,0,1)"},
						)}>{str}</Text>
						<Button ml={5} mdIcon="content-copy" title="Copy scene's id/path" enabled={segment.id != null} onClick={()=>{
							ACTSetCopiedData(new CopiedData({journalPath: {entryId: entry.id, segmentId: segment.id!, sceneIndex}}));
							const idPath = `${entry.id}/${segment.id}/${sceneIndex}`;
							CopyText(idPath); // also copy to clipboard (probably make this a setting later) [reason: for copy-pasting between dev and prod domains]
						}}/>
					</Row>
				);
			})}
		</Column>
	);
});
